export default __webpack_public_path__ + "static/Fido-Bold-e7b5f4bbfc31178d9e4020c3830a3911.woff2";